export const defaultFontStyle = {
  fontFamily: 'root',
}
